import TableButton from 'components/common/Buttons/TableButton'
import Table from 'components/common/Table'
import useQuery from 'hooks/useQuery'
import { UpdateFormContainer } from 'components/admin/Forms/UpdateFormContainer'
import * as Yup from 'yup'
import React, { useContext, useEffect, useState } from 'react'
import { Roles } from 'utils/enums'
import { AdminDataContext } from 'context/AdminDataContext'
import Accounts from '../Accounts'

const ClientsSection = ({
  getColumnForDeleting,
  title,
  endpoint,
  disableAutoScroll,
  ownerId,
}) => {
  const { mediators, specialities, clients } = useContext(AdminDataContext)

  const [selectedClient, setSelectedClient] = useState(null)
  const [clientToModify, setClientToModify] = useState(null)

  const referenceFields = {
    [Roles.Client.role]: [
      {
        data: mediators,
        fieldName: 'mediatorId',
        validation: Yup.string().required('Obligatorio'),
      },
    ],
    get [Roles.Translator.role]() {
      return this[Roles.Client.role]
    },
  }

  const inputsWithOptions = {
    [Roles.Client.role]: [
      {
        data: specialities,
        fieldName: 'speciality',
        validation: Yup.string()
          .min(3, 'Debe tener al menos 3 caracteres')
          .max(40, 'Debe tener como mucho 40 caracteres')
          .required('Obligatorio'),
      },
    ],
  }

  const aditionalColumns = [
    {
      Header: 'Empleados',
      Cell: ({
        row: {
          original: {
            id, accounts, firstName, lastName,
          },
        },
        cellCustomData,
      }) => {
        return (
          <TableButton
            selected={id === cellCustomData.selectedClient?.id}
            clickHandler={() =>
              setSelectedClient((ps) =>
                ps?.id === id
                  ? null
                  : {
                    endpoint: accounts,
                    title: `${firstName} ${lastName}`,
                    id,
                  })}
          >
            Ver Empleados
          </TableButton>
        )
      },
    },
    {
      Header: 'Tiene QR',
      Cell: ({ row: { original }, cellCustomData }) => original.allowQR ? 'Sí' : 'No',
    },
    {
      Header: 'Editar',
      Cell: ({ row: { original }, cellCustomData }) => {
        return (
          <TableButton
            selected={original.id === cellCustomData.clientToModify?.id}
            clickHandler={() =>
              setClientToModify((ps) =>
                ps?.id === original.id
                  ? null
                  : { ...original, mediatorId: ownerId || original.mediatorId })}
          >
            Editar
          </TableButton>
        )
      },
    },
    getColumnForDeleting(Roles.Client.mainPath),
  ]

  const COLUMNS_TO_REPLACE = {
    accountsCount: {
      id: 'accountsCount',
      Header: 'Cuentas en uso',
      accessor: ({ accountsCount, maxAccounts }) =>
        `${accountsCount} de ${maxAccounts}`,
    },
  }

  useEffect(() => {
    setSelectedClient(null)
  }, [endpoint])

  return (
    <>
      <div className='flex flex-col'>
        <Table
          key={ownerId || endpoint}
          title={title}
          tableData={
            ownerId ? clients.filter((c) => c.mediatorId === ownerId) : clients
          }
          endpoint={endpoint}
          aditionalColumns={aditionalColumns}
          searchOptions={SEARCH_OPTIONS}
          orderOptions={ORDER_OPTIONS}
          cellCustomData={{ selectedClient, clientToModify }}
          columnsToSkip={COLUMNS_TO_SKIP}
          columnsToReplace={COLUMNS_TO_REPLACE}
          disableAutoScroll={disableAutoScroll}
        >
          {selectedClient && (
            <Accounts
              ownerId={selectedClient.id}
              endpoint={selectedClient.endpoint}
              title={`Cuentas de ${selectedClient.title}`}
              getColumnForDeleting={getColumnForDeleting}
            />
          )}
        </Table>
      </div>
      {clientToModify && (
        <UpdateFormContainer
          referenceFields={referenceFields}
          inputsWithOptions={inputsWithOptions}
          roleObject={Roles.Client}
          initialValues={clientToModify}
          setSelectedUser={setClientToModify}
        />
      )}
    </>
  )
}

const SEARCH_OPTIONS = [
  'email',
  'firstName',
  'lastName',
  'speciality',
  'companyName',
]
const ORDER_OPTIONS = [
  'email',
  'speciality',
  'companyName',
  'firstName',
  'lastName',
  'accountsCount',
]

const COLUMNS_TO_SKIP = ['maxAccounts', 'allowQR']

export default ClientsSection
